import React from "react";

export default function Card({ title, glow = "", children, className = "", style }) {
  return (
    <div className={`card ${glow ? "glow-" + glow : ""} ${className}`} style={style}>
      {title ? <div className="card-title">{title}</div> : null}
      {children}
    </div>
  );
}
